<template>
  <div class="page-title mb-1">
    <!-- <i v-if="icon" :class="icon"></i> -->
    <div>
      <mdicon v-if="icon" size="50" :name="icon" />
      <h1>{{ main }}</h1>
    </div>
    <div class="update">
      <p v-if="lastUpdate">
        Última atualização {{ lastUpdate | formatDateTime }}, feita por
        {{ userUpdate }}
      </p>
      <!-- <p class="ml-1" v-if="userUpdate">feita por: {{ userUpdate }}</p> -->
    </div>
    <!-- <h2>{{ sub }}</h2> -->
  </div>
</template>

<script>
export default {
  name: "PageTitle",
  props: ["icon", "main", "lastUpdate", "userUpdate", "sub"],
};
</script>

<style>
.page-title {
  padding: 10px 20px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  /* box-shadow: 0 1px 5px rgba(0, 0, 0, 0.15); */
}

.page-title div {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin: 0px;
}

.page-title div > h1 {
  color: #545454;
  font-size: 1.3rem;
  margin: 0px;
}

.page-title .update {
  padding: 0px;
  color: #777;
}

.page-title .update > p {
  font-size: 0.8rem;
  margin: 0;
}

.page-title h2 {
  color: #777;
  margin-top: 5px;
  margin-bottom: 0px;
  font-size: 0.8rem;
}
</style>